import { useEffect, useState } from "react";
import API, { formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

export function PpmSettingsDialog({ open, onClose, onSaved }) {
  const [f, setF] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (open) API.get("/ppm/settings").then((r) => setF(r.data)).catch(() => setF(null)); }, [open]);
  const save = async () => {
    setSaving(true);
    try { const { data } = await API.put("/ppm/settings", f); toast.success("PPM settings saved"); onSaved?.(data); onClose(); } catch (e) { toast.error(formatApiError(e?.response?.data?.detail) || "Couldn't save"); } finally { setSaving(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="ppm-settings-dialog">
        <DialogHeader><DialogTitle>PPM settings</DialogTitle><DialogDescription>Defaults for every schedule in this workspace. A schedule can override its own lead time.</DialogDescription></DialogHeader>
        {f && (
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Create jobs (days before due)</Label><Input type="number" min="0" value={f.lead_days} onChange={(e) => setF({ ...f, lead_days: e.target.value })} data-testid="ppm-settings-lead" /></div>
            <div><Label>Grace period (days)</Label><Input type="number" min="0" value={f.grace_days} onChange={(e) => setF({ ...f, grace_days: e.target.value })} data-testid="ppm-settings-grace" /><p className="text-[10px] text-muted-foreground mt-1">Counts as overdue after due + grace.</p></div>
            <div><Label>Default start time</Label><Input type="time" value={f.start_time} onChange={(e) => setF({ ...f, start_time: e.target.value })} data-testid="ppm-settings-start" /></div>
            <div><Label>Back-fill window (days)</Label><Input type="number" min="0" value={f.lookback_days} onChange={(e) => setF({ ...f, lookback_days: e.target.value })} data-testid="ppm-settings-lookback" /><p className="text-[10px] text-muted-foreground mt-1">Older missed dates show as missed, no job.</p></div>
          </div>
        )}
        <DialogFooter><Button variant="outline" onClick={onClose}>Cancel</Button><Button onClick={save} disabled={saving || !f} data-testid="ppm-settings-save">{saving ? "Saving…" : "Save"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
